import { css, useTheme } from '@fable/theme'
import { MomBooksContentBar } from './MomBooksContentBar'
import { MomBooksContentBarMotion } from './MomBooksContentBarMotion'
import { useMomBooksGrid } from './useMomBooksGrid'
import { useStats } from '../../lib/ctx/stats'

interface Props {
  animate: boolean
}

export const MomBooksGridMain = ({ animate }: Props) => {
  const { colors } = useTheme()
  const theme = useStats((s) => s.theme)
  const { columnCount, bookStats } = useMomBooksGrid()

  const getContentBar = (books: string[]) => {
    if (!animate)
      return (
        <MomBooksContentBar
          books={books}
          max={columnCount}
          animate={false}
          show
        />
      )

    return <MomBooksContentBarMotion books={books} max={columnCount} />
  }

  return (
    <div
      className={css`
        display: grid;
        grid-template-columns: repeat(${columnCount}, 1fr);
        grid-auto-rows: 36px;
        gap: 4px 0;
      `}
    >
      {bookStats.map((s, i) => (
        <div
          key={i}
          data-testid={`mom-books-row-${i}`}
          className={css`
            grid-column: 1 / ${columnCount + 1};
            background-color: ${theme.monthlyBooks?.ghostBar ||
            colors.uiBlack20};
            border-radius: 6px;
            position: relative;
            overflow: hidden;
            transition: background-color ease-in-out 0.6s;
          `}
        >
          {s.books.length ? getContentBar(s.books) : null}
        </div>
      ))}
    </div>
  )
}
